import React, { useEffect, useState, useRef } from 'react';
import { sortFiltersBySitecore } from '../../../helpers';
import { set } from 'lodash';

export const CategoryFacet = props => {
  const { controller, labels } = props;
  const { sortedFacets, numberOfValues = 999, initialCategoriesCount } = props;
  const [state, setState] = useState(controller.state);
  const [expanded, setExpanded] = useState(true);
  const [hideCount, setHideCount] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const facetList = useRef(null);
  const [facetListHeight, setFacetListHeight] = useState(0);
  const [sortedValues, setSortedValues] = useState([]);
  const [showMore, setShowMore] = useState(null);
  const [showLess, setShowLess] = useState(null);
  const [categoriesCount, setCategoriesCount] = useState(
    initialCategoriesCount
  );

  useEffect(() => controller.subscribe(() => setState(controller.state)), []);

  const handleShowMore = () => {
    setCategoriesCount(categoriesCount + 999999); //set to a high number to show all categories
    setShowLess(true);
  };

  const handleShowLess = () => {
    setCategoriesCount(initialCategoriesCount);
    setShowLess(false);
  };

  const handleCollapseEvent = () => {
    setExpanded(false);
    setCategoriesCount(initialCategoriesCount);
  };

  useEffect(() => {
    const selected = state.values.find(value => value.state === 'selected');
    if (state?.values?.length > 0 || state?.parents?.length > 0) {
      setSortedValues(sortFiltersBySitecore(state.values, sortedFacets));
      if (firstLoad) {
        setFirstLoad(false);
        if (
          state.parents.length >= 1 &&
          state.values.length > categoriesCount
        ) {
          setShowMore(true);
        }
        if (selected) {
          setExpanded(true);
        }
      }
      resizeFacetHeight();
    }
    if (!firstLoad) {
      if (state.values.length <= categoriesCount) {
        setShowMore(null);
      } else {
        setShowMore(true);
      }
    }
  }, [state.values.length, state.parents.length, expanded, categoriesCount]);

  useEffect(() => {
    if (sortedValues.length > 0) {
      if (facetList.current && facetListHeight !== facetList.current.height) {
        resizeFacetHeight();
      }
    }
  }, [sortedValues, state.values.length, state.parents.length]);

  const resizeFacetHeight = () => {
    setFacetListHeight(facetList.current.offsetHeight);
  };

  useEffect(() => {
    window.addEventListener('coveoFacet.collapseAll', handleCollapseEvent);
    window.addEventListener('deselectFacetTree', handleDeselectFacetTree);
    window.addEventListener('resize', resizeFacetHeight);
    window.addEventListener('clickontab', resizeFacetHeight);
    return () => {
      window.removeEventListener('coveoFacet.collapseAll', handleCollapseEvent);
      window.removeEventListener('deselectFacetTree', handleDeselectFacetTree);
      window.removeEventListener('resize', resizeFacetHeight);
      window.removeEventListener('clickontab', resizeFacetHeight);
    };
  }, []);

  const handleDeselectFacetTree = e => {
    controller.toggleSelect(e.detail.value);
  };

  const handleAllCategoriesClick = () => {
    controller.deselectAll();
    setCategoriesCount(initialCategoriesCount);
    setShowLess(false);
  };

  const handleClickableTreeFacetClick = value => {
    controller.toggleSelect(value);
    setShowLess(false);
  };

  function getUniqueKeyForValue(value) {
    return value.path.join('>');
  }

  if (!state.values.length && !state.parents.length) {
    return;
  }

  const renderParentsChildren = () => {
    return (
      <>
        {state.parents?.length > 0 ? (
          <>
            <ul className="coveo-document-list-tree__children">
              <li
                className="system-list__filter-tree-item"
                data-expanded="true"
              >
                <button
                  onClick={() => {
                    handleAllCategoriesClick();
                  }}
                >
                  {labels.categoryFacetAllCategories
                    ? labels.categoryFacetAllCategories
                    : 'All Categories'}
                </button>
              </li>
              {clickableTreeFacet(state.parents[0], true)}
              {state.parents?.length > 1 ? (
                <>
                  {clickableTreeFacet(state.parents[1], true)}
                  <li>
                    <ul className="coveo-document-list-tree__grandchildren">
                      {state.parents?.length > 2 ? (
                        <>{clickableTreeFacet(state.parents[2], true)}</>
                      ) : (
                        <>
                          {state.values.map((value, index) => (
                            <React.Fragment key={value.value}>
                              {index >= categoriesCount && showMore ? null : (
                                <>{clickableTreeFacet(value)}</>
                              )}
                            </React.Fragment>
                          ))}
                          <li>
                            <div className="coveo-facet__show-buttons">
                              {showLess === true && (
                                <>
                                  <button
                                    className="coveo-facet__show-button"
                                    onClick={handleShowLess}
                                  >
                                    {labels.showLess}
                                  </button>
                                </>
                              )}
                              {showMore && (
                                <button
                                  className="coveo-facet__show-button"
                                  onClick={handleShowMore}
                                >
                                  {labels.showMore}
                                </button>
                              )}
                            </div>
                          </li>
                        </>
                      )}
                    </ul>
                  </li>
                </>
              ) : (
                <>
                  {sortedValues.map((value, index) => (
                    <React.Fragment key={value.value}>
                      {index >= categoriesCount && showMore ? null : (
                        <>{clickableTreeFacet(value)}</>
                      )}
                    </React.Fragment>
                  ))}
                  <li>
                    <div className="coveo-facet__show-buttons">
                      {showLess === true && (
                        <>
                          <button
                            className="coveo-facet__show-button"
                            onClick={handleShowLess}
                          >
                            {labels.showLess}
                          </button>
                        </>
                      )}
                      {showMore && (
                        <button
                          className="coveo-facet__show-button"
                          onClick={handleShowMore}
                        >
                          {labels.showMore}
                        </button>
                      )}
                    </div>
                  </li>
                </>
              )}
            </ul>
          </>
        ) : (
          <>{sortedValues.map(value => clickableTreeFacet(value))}</>
        )}
      </>
    );
  };

  const clickableTreeFacet = (value, parent = false) => (
    <li
      className={`system-list__filter-tree-item${parent ? ' no-arrow' : ''}`}
      key={getUniqueKeyForValue(value)}
      data-expanded={parent ? true : false}
    >
      <button
        onClick={() => {
          handleClickableTreeFacetClick(value);
        }}
      >
        {value.value}
      </button>
      {!hideCount && (
        <span className="system-list__filter-count">
          ({value.numberOfResults})
        </span>
      )}
    </li>
  );

  return (
    <div className="coveo-search-results__facet accordion-item">
      <h3
        aria-label={props.title}
        className="coveo-search-results__facet-heading accordion-item__title"
      >
        <button
          aria-expanded={expanded}
          aria-controls={`coveo-facet-${props.title}`}
          aria-label={`${props.title}`}
          className="coveo-search-results__facet-toggle accordion-item__trigger"
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          {expanded === true ? (
            <svg
              className="accordion-item__trigger-icon accordion-item__trigger-icon--collapse"
              height="16"
              role="presentation"
              viewBox="0 0 120 120"
              width="16"
            >
              <use xlinkHref="#minus-regular"></use>
            </svg>
          ) : (
            <svg
              className="accordion-item__trigger-icon accordion-item__trigger-icon--expand"
              height="16"
              role="presentation"
              viewBox="0 0 120 120"
              width="16"
            >
              <use xlinkHref="#plus-regular"></use>
            </svg>
          )}
          <span className="accordion-item__trigger-text">{props.title}</span>
        </button>
      </h3>
      <div
        id={`coveo-facet-${props.title}`}
        className="coveo-search-results__facet-value-list accordion-item__panel"
        data-expanded={expanded}
        style={{
          '--coveo-facet-value-list-height': `${facetListHeight}px`
        }}
      >
        <div ref={facetList} className="accordion-item__panel-inner">
          <div className="accordion-item__copy">
            <ul className="system-list__filter-list">
              {renderParentsChildren()}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
